import { Component, OnInit, ChangeDetectorRef, ViewChildren, QueryList, ElementRef, OnDestroy, AfterViewInit, Inject, Renderer2 } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { DTO } from '../../app/core/models/dto';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-promotion-leaderboard',
    templateUrl: 'promotion-leaderboard.component.html'
})
export class PromotionLeaderboardComponent implements OnInit, OnDestroy {
    @ViewChildren('myRank') myRankMarking: QueryList<ElementRef>;
    @ViewChildren('runningPrizeLevel') runningPrizeLevelMarking: QueryList<ElementRef>;

    public promotionId: number;
    public promotionType: DTO.Enums.PromotionType;
    public nickname: string;
    public brandId: string;
    public siteId: string;
    public isMaintenance = false;
    public playerLimit: number;

    private queryParamSubscription: Subscription;
    public nationality: string;
    public leaderboardType: DTO.Enums.LeaderboardType;
    public optInGroupName: string;
    public backgroundColor: string;
    public prizeVisibility = false;
    public onlyCoin = false;
    public hideSymbol = false;
    public hideCustomSymbol = false;
    public hideRank = false;
    public focusFirstPlayer = false;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private cd: ChangeDetectorRef,
        private translateService: TranslateService) {
        this.translateService.setDefaultLang('en');
    }

    public ngOnInit() {
        this.route.queryParamMap.subscribe(this.checkParams);
    }

    private checkParams = (params: ParamMap) => {
        if (params.has('lang')) {
            const langParam = params.get('lang');
            const langLength = langParam.length;
            let lang = Array.isArray(langParam) ? langParam[langLength - 1] : langParam;
            if (lang === 'zh') {
                lang = 'zh-cn';
            }
            this.translateService.use(lang);
        }

        if (params.has('nickname')) {
            this.nickname = params.get('nickname');
        }

        if (params.has('brandId')) {
            this.brandId = params.get('brandId');
        }

        if (params.has('siteId')) {
            this.siteId = params.get('siteId');
        }

        if (params.has('limit') && !isNaN(Number(params.get('limit')))) {
            this.playerLimit = Number(params.get('limit'));
        }

        if (params.has('nationality')) {
            this.nationality = params.get('nationality');
        }

        if (params.has('lType')) {
            this.leaderboardType = params.get('lType').toUpperCase() as DTO.Enums.LeaderboardType;
        } else {
            this.leaderboardType = DTO.Enums.LeaderboardType.NORMAL;
        }

        if (params.has('ogName')) {
            this.optInGroupName = params.get('ogName');
        }

        if (params.has('bg')) {
            this.backgroundColor = `#${params.get('bg')}`;
            this.renderer.setStyle(this.document.body, 'background', this.backgroundColor);
        }

        this.promotionId = Number(params.get('promotionId'));
        this.prizeVisibility = params.has('prize') ? 'on' === params.get('prize') : true;
        this.onlyCoin = params.has('onlyCoin') ? 'on' === params.get('onlyCoin').toLowerCase() : false;
        this.hideSymbol = params.has('hs') ? 'on' === params.get('hs').toLowerCase() : false;
        this.hideCustomSymbol = params.has('hcs') ? 'on' === params.get('hcs').toLowerCase() : false;
        this.hideRank = params.has('hr') ? 'on' === params.get('hr').toLowerCase() : false;
        this.focusFirstPlayer = params.has('fp') ? 'on' === params.get('fp').toLowerCase() : false;

        this.cd.markForCheck();
    }

    ngOnDestroy() {
        this.queryParamSubscription.unsubscribe();
    }
}
